import { render, staticRenderFns } from "./endetlawjq.vue?vue&type=template&id=bb05eb24&scoped=true&"
import script from "./endetlawjq.vue?vue&type=script&lang=js&"
export * from "./endetlawjq.vue?vue&type=script&lang=js&"
import style0 from "./endetlawjq.vue?vue&type=style&index=0&id=bb05eb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb05eb24",
  null
  
)

export default component.exports